module.exports = __webpack_public_path__ + "img/4.b6daa3e4.jpg";